import React from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import "./Slider.css";

import Banner1 from "./Banners/Banner1";
import Banner2 from "./Banners/Banner2";
import Banner3 from "./Banners/Banner3";

export const Slider = (props) => {

  const [pause, setPause] = React.useState(false);
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const timer = React.useRef();

  const [sliderRef, slider] = useKeenSlider({
    loop: true,
    initial: 0,
    controls: false,
    duration: 1000,
    dragStart: () => {
      setPause(true);
    },
    dragEnd: () => {
      setPause(false);
    },
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
  });

  React.useEffect(() => {
    sliderRef.current.addEventListener("mouseover", () => {
      setPause(true);
    });
    sliderRef.current.addEventListener("mouseout", () => {
      setPause(false);
    });
  }, [sliderRef]);

  React.useEffect(() => {
    timer.current = setInterval(() => {
      if (!pause && slider) {
        slider.next();
      }
    }, 80000);
    return () => {
      clearInterval(timer.current);
    };
  }, [pause, slider]);

  const btnSettings = {
    variant: "contained",
    color: "primary",
    text: "Descarga la app"
  }

  return (
    <div className="navigation-wrapper">
      <div ref={sliderRef} className="keen-slider">
        <div className="keen-slider__slide number-slide1">
          <Banner1 btn={btnSettings} />
        </div>
        <div className="keen-slider__slide number-slide2">
          <Banner2 btn={btnSettings} />
        </div>
        <div className="keen-slider__slide number-slide3">
          <Banner3 btn={btnSettings} />
        </div>
      </div>

      {slider && (
        <div className="dots1">
          {[...Array(slider.details().size).keys()].map((idx) => {
            return (
              <button
                key={idx}
                onClick={() => {
                  slider.moveToSlideRelative(idx);
                }}
                className={"dotP" + (currentSlide === idx ? " active" : "")}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
